import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useSubscription} from '../hooks/useSubscription';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {IndexPage as SubscriptionItems} from "../../subscription-items/pages/IndexPage.tsx";

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useSubscription(componentId);

    const {
        mode,
        tools,
    } = useEditPageTools();

    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.description ? component.description : component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?

                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={component}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>
                        <SimplePageContentWrapper>
                            <SubscriptionItems/>
                        </SimplePageContentWrapper>
                    </Grid.Col>
                </Grid>


                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={component}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
